import { FormsConstants } from '@evorait/pace-forms';

export type ServiceActivityState = Readonly<FormsConstants.SERVICE_ACTIVITY_TYPES | undefined>;

export const initialServiceActivityState: Readonly<ServiceActivityState> = undefined;
